"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _withScopeId = (n) => ((0, vue_2.pushScopeId)("data-v-1567330c"), n = n(), (0, vue_2.popScopeId)(), n);
const _hoisted_1 = { class: "title-wrapper" };
const _hoisted_2 = { class: "content-wrapper ask-slot-message text-center" };
const _hoisted_3 = { class: "message-date" };
const _hoisted_4 = { class: "message-name" };
const _hoisted_5 = { class: "footer-btn-wrapper flex-justify-between" };
const _hoisted_6 = { class: "d-flex" };
const vue_3 = require("vue");
const Modal_vue_1 = __importDefault(require("../Modal.vue"));
const shift_1 = require("../../js/shift");
const errors_1 = __importDefault(require("../../js/errors"));
const slotRequests_1 = require("../../requests/slotRequests");
const PaperPlaneIcon_vue_1 = __importDefault(require("../icons/PaperPlaneIcon.vue"));
exports.default = (0, vue_1.defineComponent)({
    __name: 'AskSlotModal',
    props: {
        userId: {
            type: Number,
            required: true,
        },
        branchId: {
            type: Number,
            required: true,
        }
    },
    setup(__props, { expose: __expose }) {
        const isVisible = (0, vue_3.ref)(false);
        const messageDate = (0, vue_3.ref)("");
        const messageName = (0, vue_3.ref)("");
        let slotId = 0;
        let dateUnix = "";
        const props = __props;
        function openModal(date, id, msgDate, msgName) {
            dateUnix = date;
            slotId = id;
            messageDate.value = msgDate;
            messageName.value = msgName;
            isVisible.value = true;
        }
        function closeModal() {
            isVisible.value = false;
        }
        async function handleSlotOption(statusNum) {
            if (statusNum === 0) {
                (0, shift_1.handleOpenShiftSlotModal)(dateUnix, slotId);
                closeModal();
                return;
            }
            (0, shift_1.setSlotAskStatus)(slotId, statusNum);
            const data = {
                slotId: slotId,
                status: statusNum === 2 ? "accepted" : "rejected",
            };
            try {
                const result = await (0, slotRequests_1.updateSlotStatusPostRequest)(props.branchId, props.userId, data);
                if (!result.success || !result.workrequest) {
                    (0, shift_1.openAlertModal)(errors_1.default.SLOT.UPDATE);
                    return;
                }
                (0, shift_1.slotModalOnSubmit)(slotId, false);
                // Declined
                if (statusNum === 3) {
                    window.location.reload();
                    return;
                }
                (0, shift_1.handleOpenShiftSlotModal)(dateUnix, slotId);
            }
            catch (err) {
                (0, shift_1.openAlertModal)(errors_1.default.SLOT.UPDATE);
            }
            finally {
                closeModal();
            }
        }
        __expose({ openModal });
        return (_ctx, _cache) => {
            return (isVisible.value)
                ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(Modal_vue_1.default, {
                    key: 0,
                    onCloseModal: closeModal,
                    hasTitleDivider: true
                }, {
                    "header-title": (0, vue_2.withCtx)(() => [
                        (0, vue_2.createElementVNode)("div", _hoisted_1, [
                            (0, vue_2.createVNode)(PaperPlaneIcon_vue_1.default, { class: "request-icon" }),
                            (0, vue_2.createTextVNode)(" シフト要請 ")
                        ])
                    ]),
                    content: (0, vue_2.withCtx)(() => [
                        (0, vue_2.createElementVNode)("div", _hoisted_2, [
                            (0, vue_2.createElementVNode)("span", _hoisted_3, (0, vue_2.toDisplayString)(messageDate.value), 1 /* TEXT */),
                            (0, vue_2.createElementVNode)("span", _hoisted_4, (0, vue_2.toDisplayString)(messageName.value), 1 /* TEXT */)
                        ])
                    ]),
                    "footer-btn": (0, vue_2.withCtx)(() => [
                        (0, vue_2.createElementVNode)("div", _hoisted_5, [
                            (0, vue_2.createElementVNode)("div", _hoisted_6, [
                                (0, vue_2.createElementVNode)("button", {
                                    class: "oplus-btn mr-1",
                                    onClick: _cache[0] || (_cache[0] = ($event) => (handleSlotOption(2)))
                                }, "承認"),
                                (0, vue_2.createElementVNode)("button", {
                                    class: "oplus-btn",
                                    onClick: _cache[1] || (_cache[1] = ($event) => (handleSlotOption(3)))
                                }, "拒否")
                            ]),
                            (0, vue_2.createElementVNode)("button", {
                                class: "oplus-btn oplus-alt-btn",
                                onClick: _cache[2] || (_cache[2] = ($event) => (handleSlotOption(0)))
                            }, "編集")
                        ])
                    ]),
                    _: 1 /* STABLE */
                }))
                : (0, vue_2.createCommentVNode)("v-if", true);
        };
    }
});
